<template>
  <div>
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-button no="1" type="primary" :disabled="readonly" @click="pm.addBtnClickHandler()">{{ $t('SeaExport.Add2') }}</el-button>
          <el-button no="2" type="danger" :disabled="readonly" @click="pm.delBtnClickHandler()">{{ $t('SeaExport.Delete') }}</el-button>
          <el-button no="3" type="danger" :disabled="readonly" @click="pm.fentanBtnClickHandler()">{{ $t('SeaExport.PriceCalculation') }}</el-button>
          <el-button no="4" type="primary" @click="pm.downTemplateBtn_clickHandler()">{{ $t('SeaExport.TemplateDownload') }}</el-button>

          <el-upload
            no="5"
            :disabled="readonly"
            :action="URL.seaExport.poItemsImportExcel"
            :headers="{sessionId:user.sessionId}"
            :data="{ jobUuid: job.uuid, jobNo: job.jobNo }"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            style="display: inline-block"
          >
            <el-button type="primary" :disabled="readonly" style="marginLeft: 5px;">{{ $t('SeaExport.ExcelImport') }}</el-button>
          </el-upload>
          <el-button no="6" type="primary" @click="pm.exportBtnClickHandler()">{{ $t('SeaExport.ExcelExport') }}</el-button>
          <el-button no="7" type="success" @click="pm.onBatchPrint()">{{ $t('SeaExport.print') }}</el-button>
        </div>
      </div>
    </div>
    <div class="section" style="flex-grow:1;padding:10px">
      <cargo-ag-grid
        config-module="20000005"
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :column-defs="columnDefs"
        :row-data="poItems"
        style="width:100%;height:100%;min-height: 500px"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
    <!-- 添加装箱信息弹出窗 -->
    <trade-detail-container-linked-dialog
      :visible.sync="tradeDetailContainerLinkedDialog.visible"
      :job="job"
      :sel-po-items="tradeDetailContainerLinkedDialog.selPoItems"
      :related-container-usage="tradeDetailContainerLinkedDialog.relatedContainerUsage"
      @linkUsagesEventHandler="linkUsagesEventHandler"
    />

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

import { TabTradeDetailBase } from './TabTradeDetailBase'
import { AbstractEntity as Job } from '@/class/model/AbstractEntity'
import TradeDetailContainerLinkedDialog
  from '@/components/Cargo/Job/tradeDetailContainerLinkedDialog'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { basicCacheKeys as selectTypeNames } from '@/utils/cacheConfig'
import ColumnUtils from '@/utils/ColumnUtils'
import { formatNumberToThousands } from '@/utils'
import { isNumber } from '@/utils/validate'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import { deepCopy } from '@/utils/commonUtil'

export default {
  name: 'TabTradeDetail',
  components: { TradeDetailContainerLinkedDialog, cargoTemplateSelectorDialog },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      URL,
      pm: new TabTradeDetailBase(this),
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: { // 添加编辑组件
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridSelectEditor,
          CargoAgGridCommonTextareaEditor
        }
      },
      rowData: [],
      gridApi: null,
      tradeDetailContainerLinkedDialog: {
        visible: false,
        selPoItems: [],
        relatedContainerUsage: []
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: new SeaImportJob(),
        category: 'SIPOITEMS',
        data: {
          POITEMS_UUID: []
        }
      },
      job: new Job().fillDefaultValue().getData(),
      poItems: [],
      delPoItemsUuids: [], // 删除的uuid
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    user() {
      return this.context.user || {}
    },
    columnDefs() {
      const columnDefs =
         [
           {
             headerName: '',
             field: '',
             headerCheckboxSelection: true,
             checkboxSelection: true,
             sortable: false,
             suppressMenu: true,
             suppressSizeToFit: true,
             resizable: false
           },
           {
             headerName: this.$t('SeaExport.OrderNo'),
             colId: 'orderNo',
             field: 'orderNo',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'ACPT',
             field: 'moduleCode',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.CaseNo'),
             field: 'caseNo',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.Item'),
             field: 'itemNo',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.Sub'),
             field: 'subItemNo',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'SUPPLY PARTS NO',
             field: 'supplyPartNo',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'ORDER PARTS NO',
             field: 'orderPartNo',
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: 'HS CODE',
             field: 'hsCode',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.isRelated'),
             field: 'related',
             width: 120,
             hide: true,
             cellRenderer: (params) => {
               return this.relatedLabelFunc(params.value)
             }
           },
           {
             headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
             field: 'chineseCommodity',
             width: 120,
             editable: this.isEdit,
             cellEditor: 'CargoAgGridCommonTextareaEditor'
           },
           {
             headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
             field: 'englishCommodity',
             width: 120,
             hide: true,
             editable: this.isEdit,
             cellEditor: 'CargoAgGridCommonTextareaEditor',
             cellEditorParams: {
               autoUppercase: this.isUppercaseByConfig
             }
           },
           {
             headerName: this.$t('SeaExport.Size2'),
             field: 'itemSpec',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.CommodityClassification'),
             field: 'customsCommodity',
             width: 100,
             editable: this.isEdit,
             cellEditor: 'CargoAgGridCommonTextareaEditor'
           },
           {
             headerName: this.$t('SeaExport.Qty'),
             field: 'quantity',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.UnitOfMeasurement'),
             field: 'measure',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.NetWeight'),
             field: 'netWeight',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: 'WEIGHT',
             field: 'grossWeight',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.Cubage'),
             field: 'cubage',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: 'AMOUNT',
             field: 'purchaseAmount',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               },
               valueChanged: params => {
                 return this.pm.calculateAmount(params.data)
               }
             }
           },
           {
             headerName: 'AMOUNT(RMB)',
             field: 'purchaseAmountRMB',
             width: 150,
             cellRenderer: (params) => {
               return this.purchaseAmountRMBLabelFun(params.data)
             }
           },
           {
             headerName: this.$t('SeaExport.CustomsDutyRate'),
             field: 'purchaseTariffRate',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               },
               valueChanged: params => {
                 this.pm.calculateAmount(params.data)
               }
             }
           },
           {
             headerName: this.$t('SeaExport.CustomsDuties'),
             field: 'purchaseTariffAmount',
             width: 120
           },
           {
             headerName: this.$t('SeaExport.IncrementValueDutyRate'),
             field: 'purchaseValRate',
             width: 120,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               },
               valueChanged: params => {
                 this.pm.calculateAmount(params.data)
               }
             }
           },
           {
             headerName: this.$t('SeaExport.IncrementValueDuty'),
             field: 'purchaseValAmount',
             width: 120
           },
           {
             headerName: this.$t('SeaExport.ConsumptionDutyRate'),
             field: 'purchaseExciseRate',
             width: 110,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               },
               valueChanged: params => {
                 this.pm.calculateAmount(params.data)
               }
             }
           },
           {
             headerName: this.$t('SeaExport.ConsumptionDuty'),
             field: 'purchaseExciseAmount',
             width: 100
           },
           {
             headerName: this.$t('SeaExport.ConsolidatedTax'),
             field: 'totalRateAmount',
             width: 100,
             cellRenderer: (params) => {
               return this.totalRateAmountLabelFun(params.data)
             }
           },
           {
             headerName: this.$t('SeaExport.Currency'),
             field: 'purchaseCurrency',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-advance-select',
               selectType: selectTypeNames.basic_data_Currency,
               tagValue: 'code',
               tagName: 'code'
             }
           },
           {
             headerName: this.$t('SeaExport.ExchangeRate'),
             field: 'pruchaseExchangeRate',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               },
               valueChanged: params => {
                 this.pm.calculateAmount(params.data)
               }
             }
           },
           {
             headerName: this.$t('SeaExport.CargoPrice'),
             field: 'sellPrice',
             width: 100
           },
           {
             headerName: this.$t('SeaExport.Tax'),
             field: 'sellValAmount',
             width: 100
           },
           {
             headerName: this.$t('SeaExport.TaxRate'),
             field: 'sellValRate',
             width: 100,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input',
               attrs: {
                 complexTextConverter: (data, val) => {
                   return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 2))
                 },
                 checkInput: (val) => {
                   return isNumber(val)
                 }
               }
             }
           },
           {
             headerName: this.$t('SeaExport.SerialNumber'),
             headerTooltip: this.$t('SeaExport.SerialNumber'),
             field: 'serialNumber',
             hide: true,
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.Brand'),
             headerTooltip: this.$t('SeaExport.Brand'),
             field: 'brand',
             hide: true,
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.ProductiveYear'),
             headerTooltip: this.$t('SeaExport.ProductiveYear'),
             field: 'productiveYear',
             hide: true,
             width: 150,
             editable: this.isEdit,
             cellEditor: 'CargoAgGridSelectEditor',
             cellEditorParams: {
               options: this.clnYears(),
               tagName: 'name',
               tagValue: 'value'
             }
           },
           {
             headerName: this.$t('SeaExport.CustomsValue'),
             headerTooltip: this.$t('SeaExport.CustomsValue'),
             field: 'customsValue',
             hide: true,
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.UnitType'),
             headerTooltip: this.$t('SeaExport.UnitType'),
             field: 'unitType',
             hide: true,
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.DeviceType'),
             headerTooltip: this.$t('SeaExport.DeviceType'),
             field: 'deviceType',
             hide: true,
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.CountryOrigin1'),
             headerTooltip: this.$t('SeaExport.CountryOrigin1'),
             field: 'countryOrigin',
             hide: true,
             width: 150,
             cellRendererFramework: 'agGridColumnEdit',
             custom: {
               isEdit: this.isEdit,
               tag: 'cargo-cell-input'
             }
           },
           {
             headerName: this.$t('SeaExport.DeviceStatus'),
             headerTooltip: this.$t('SeaExport.DeviceStatus'),
             field: 'deviceStatus',
             hide: true,
             width: 150,
             editable: this.isEdit,
             cellEditor: 'CargoAgGridSelectEditor',
             cellEditorParams: {
               options: [{ name: this.$t('SeaExport.BrandNew'), value: 0 }, { name: this.$t('SeaExport.SecondHand'), value: 1 }],
               tagName: 'name',
               tagValue: 'value'
             },
             valueFormatter: params => {
               return params.value === 0 ? this.$t('SeaExport.BrandNew') : this.$t('SeaExport.SecondHand')
             }
           }
         ]
      return columnDefs
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.job = row
      await this.pm.loadPoItems()
      if (this.isEdit && this.job.uuid) {
        this.$emit('syncData', { poItems: deepCopy(this.job.poItems) })
      }
      this.isUppercaseByConfig = Number(this.context.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    },
    // 保存
    getSubmitData() {
      return {
        poItems: this.poItems,
        delPoItemsUuids: this.delPoItemsUuids
      }
    },
    beforeUpload(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        this.pm.onImportSucceeded(response.data)
      } else {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    clnYears() {
      const arrYear = []
      arrYear.push({ name: this.$t('SeaExport.Unknown'), value: '不详' })
      const date = new Date().getFullYear()
      for (let i = date; i >= date - 30; i--) {
        arrYear.push({ name: i.toString(), value: i.toString() })
      }
      return arrYear
    },
    relatedLabelFunc(value) {
      return value === 1 ? this.$t('Message.Yes') : this.$t('Message.No')
    },
    totalRateAmountLabelFun(data) {
      const poItems = data
      if (poItems) {
        return Number(poItems.purchaseTariffAmount + poItems.purchaseValAmount + poItems.purchaseExciseAmount).toFixed(2)
      }
      return ''
    },
    purchaseAmountRMBLabelFun(data) {
      var poItems = data
      if (poItems) {
        return (Math.round(poItems.purchaseAmount * poItems.pruchaseExchangeRate)).toFixed(2)
      }
      return ''
    },
    // 添加装箱信息(选择后逻辑处理)
    linkUsagesEventHandler(data) {
      this.pm.linkUsagesEventHandler(data)
    }
  }
}
</script>

<style>
</style>
